import { TagList } from '@xing-com/crate-jobs-domain-serps-components-tag-list';
import type { SerpsListItem } from '@xing-com/crate-jobs-domain-serps-constants';
import { capitalizeFirstLetter } from '@xing-com/crate-jobs-domain-serps-helpers';
import type { JobDetails } from '@xing-com/crate-jobs-helpers';

type Props = {
  jobDetails: JobDetails;
  linkboxes?: {
    kind: string;
    entries: SerpsListItem[];
  }[];
  jobRole: string;
};

export const LinkboxesModule: React.FC<Props> = ({
  jobDetails,
  linkboxes,
  jobRole,
}) => {
  const { location } = jobDetails;

  return (
    <>
      {linkboxes?.map((item: { kind: string; entries: SerpsListItem[] }) => (
        <TagList
          key={item.kind}
          headerCopyKey={`XJM_SEO_LINK_BOXES_${item.kind.toLocaleUpperCase()}`}
          headerCopyValues={{
            categoryValue: capitalizeFirstLetter(jobRole),
            subcategoryValue: location?.city || '',
          }}
          serpsList={item.entries}
          showCount="hide"
          noMargin
        />
      ))}
    </>
  );
};
